// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".environment-version[data-v-5463de00] {\n  position: absolute;\n  top: 4px;\n  right: 8px;\n}\n.environment-version .gitlab-link[data-v-5463de00] {\n  text-decoration: underline;\n}\n", ""]);
// Exports
module.exports = exports;
